import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { NoAuthGuard } from '@core/auth/guards/noAuth.guard';

const routes: Routes = [
  // Redirect empty path to '/example'
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

  // Redirect signed-in user to the '/example'
  //
  // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

  // Auth routes for guests
  {
    path: '',
    canMatch: [NoAuthGuard],
    children: [
      { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.SignInModule) },
    ]
  },


  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/admin/dashboard/dashboard.module').then(m => m.DashboardPageModule)
      },
      {
        path: 'products',
        loadChildren: () => import('./modules/admin/products/products.module').then(m => m.ProductsPageModule)
      },
      {
        path: 'pickings',
        loadChildren: () => import('./modules/admin/picking/picking.module').then(m => m.PickingPageModule)
      },
      {
        path: 'bins',
        loadChildren: () => import('./modules/admin/bins/bins.module').then(m => m.BinsPageModule)
      },

      {
        path: 'tidyup',
        loadChildren: () => import('./modules/admin/tidy-up/tidy-up.module').then(m => m.TidyUpPageModule)
      },
      {
        path: 'restocking',
        loadChildren: () => import('./modules/admin/restocking/restocking.module').then(m => m.RestockingPageModule)
      },
      /**
       * Detail pages
       */
      {
        path: 'product',
        loadChildren: () => import('./modules/admin/product-detail/product-detail.module').then(m => m.ProductDetailPageModule)
      },
      {
        path: 'bin',
        loadChildren: () => import('./modules/admin/bin-detail/bin-detail.module').then(m => m.BinDetailPageModule)
      },
      {
        path: 'picking',
        loadChildren: () => import('./modules/admin/picking-cart-detail/picking-cart-detail.module').then(m => m.PickingCartDetailPageModule)
      },
      // {
      //   path: 'packing',
      //   loadChildren: () => import('./modules/admin/packing/packing.module').then(m => m.PackingPageModule)
      // },

      {
        path: 'packing',
        loadChildren: () => import('./modules/admin/packaging/packaging.module').then(m => m.PackagingPageModule)
      },
      {
        path: 'packaging-detail',
        loadChildren: () => import('./modules/admin/packaging-detail/packaging-detail.module').then(m => m.PackagingDetailPageModule)
      },
      {
        path: 'active-carts',
        loadChildren: () => import('./modules/admin/active-carts/active-carts.module').then(m => m.ActiveCartsPageModule)
      },
      {
        path: 'repositions',
        loadChildren: () => import('./modules/admin/repositions/repositions.module').then(m => m.RepositionsPageModule)
      },
      {
        path: 'pending-warehouse',
        loadChildren: () => import('./modules/admin/pending-warehouse/pending-warehouse.module').then(m => m.PendingWarehousePageModule)
      },
      {
        path: 'picking-transfers',
        loadChildren: () => import('./modules/admin/picking-transfers/picking-transfers.module').then(m => m.PickingTransfersPageModule)
      },
      {
        path: 'reposition',
        loadChildren: () => import('./modules/admin/reposition-detail/reposition-detail.module').then(m => m.RepositionDetailPageModule)
      }
    ]
  },
  {
    path: 'restocking',
    loadChildren: () => import('./modules/admin/restocking/restocking.module').then(m => m.RestockingPageModule)
  },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
